export default "__VITE_ASSET__f440a4d4__"